import { useState } from 'react';
import { Dialog, api, useToast } from './_barrel.js';


        // ===== Archive Subject =====
        function ArchiveSubjectDialog({ token, subject, onClose, onSuccess }) {
            const [reason, setReason] = useState('');
            const [submitting, setSubmitting] = useState(false);
            const [error, setError] = useState(null);
            const toast = useToast();

            const submit = async (e) => {
                e.preventDefault();
                if (!reason.trim()) return;
                setSubmitting(true);
                setError(null);
                try {
                    await api(`/api/v1/subjects/${subject.id}`,
                        { method: 'DELETE', body: JSON.stringify({ deletion_reason: reason.trim() }) },
                        token);
                    toast('Subject archived');
                    onSuccess?.();
                    onClose();
                } catch (err) { setError(err.message); }
                finally { setSubmitting(false); }
            };

            return (
                <Dialog onClose={onClose} title={`Archive Subject — ${subject.display_name || subject.full_name}`}>
                    <form onSubmit={submit} className="space-y-4">
                        <div className="text-sm text-muted">
                            Archiving a subject removes them from the active subjects list and stops monitoring. Historic incidents, assessments, and audit chain entries are retained. The subject can be restored later by an admin.
                        </div>
                        <div>
                            <label>Reason for Archiving *</label>
                            <textarea rows="3" value={reason} onChange={e => setReason(e.target.value)} required
                                placeholder="e.g. Engagement ended on 2026-04-30; retention policy now applies." />
                        </div>
                        {error && <div className="text-[var(--red)] text-sm">{error}</div>}
                        <div className="flex justify-end gap-3 pt-2">
                            <button type="button" className="btn-ghost" onClick={onClose}>Cancel</button>
                            <button type="submit" className="btn-gold" disabled={submitting || !reason.trim()}
                                style={{background: 'var(--red)', color: '#fff', borderColor: 'var(--red)'}}>
                                {submitting ? 'Archiving…' : 'Archive Subject'}
                            </button>
                        </div>
                    </form>
                </Dialog>
            );
        }

export { ArchiveSubjectDialog };
